class SbProductForm extends HTMLElement {
  connectedCallback() {
    const variantsNode = this.querySelector('[data-variants-json]');
    const pricesNode = this.querySelector('[data-prices-json]');
    if (!variantsNode || !pricesNode) return;

    const sizesNode = this.querySelector('[data-variant-sizes-json]');

    try {
      this.variants = JSON.parse(variantsNode.textContent);
      this.prices = JSON.parse(pricesNode.textContent);
      this.variantSizes = sizesNode ? JSON.parse(sizesNode.textContent) : {};
    } catch (err) {
      console.warn('[sb-product-form] failed to parse JSON blobs', err);
      return;
    }

    this.idInput = this.querySelector('[data-variant-id-input]');
    this.spInput = this.querySelector('[data-selling-plan-input]');
    this.priceEl = this.querySelector('[data-atc-price]');
    this.labelEl = this.querySelector('[data-atc-label]');
    this.atcBtn = this.querySelector('button[type="submit"][name="add"]');
    this.freqWrap = this.querySelector('[data-frequency-wrapper]');
    this.freqSelect = this.querySelector('[data-frequency-select]');

    this.strings = {
      addToCart: this.dataset.stringAddToCart || 'Add to cart',
      soldOut: this.dataset.stringSoldOut || 'Sold out',
    };

    this.addEventListener('change', this.onChange);
    this.sync();
  }

  onChange = (event) => {
    const target = event.target;
    if (target.matches('[data-variant-pill] input')) {
      this.onVariantChange();
    } else if (target.matches('[name="purchase_type"]')) {
      this.onPurchaseTypeChange();
    } else if (target === this.freqSelect) {
      this.onFrequencyChange();
    }
  };

  onVariantChange() {
    const pill = this.querySelector('[data-variant-pill] input:checked')?.closest('[data-variant-pill]');
    if (!pill) return;
    const variantId = pill.dataset.variantId;
    if (!variantId) return;

    this.idInput.value = variantId;

    const variant = this.variants.find((v) => String(v.id) === String(variantId));

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    history.replaceState({}, '', url);

    this.updateVariantLabels(variantId);
    this.updateVariantSize(variantId);

    if (variant) {
      this.dispatchEvent(
        new CustomEvent('sb:variant-change', { detail: { variant }, bubbles: true })
      );
      const stickyCart = document.getElementById('stickyAtc');
      if (stickyCart) {
        // Update hidden variant ID input
        const stickyCartVariantInput = stickyCart.querySelector('[name="id"]');
        if (stickyCartVariantInput) stickyCartVariantInput.value = variant.id;

        // Update sticky cart price
        const stickyCartPrice = stickyCart.querySelector('.sb-atc__price');
        if (stickyCartPrice) {
          // Try to use correct price format (money without trailing zeros as in Shopify's liquid)
          const price =
            this.prices?.[`${variant.id}:onetime`] ??
            this.prices?.[`${variant.id}:null`] ??
            variant.price;
          stickyCartPrice.textContent = price;
        }

        const stickyCartVariantTitle = stickyCart.querySelector('.sb-product-info__variant-title');
        if (stickyCartVariantTitle) {
          const optionName = stickyCartVariantTitle.dataset.optionName;
          stickyCartVariantTitle.textContent = optionName ? `${optionName}: ${variant.title}` : variant.title;
        }

        // // Update sticky cart main price (.sa-price__default)
        // const stickyCartMainPrice = stickyCart.querySelector('.sa-price__default');
        // if (stickyCartMainPrice) {
        //   const price =
        //     this.prices?.[`${variant.id}:onetime`] ??
        //     this.prices?.[`${variant.id}:null`] ??
        //     variant.price;
        //   stickyCartMainPrice.textContent = price;
        // }

        // Update button label and disabled state
        const stickyCartButton = stickyCart.querySelector('.sb-atc__label');
        const stickyCartBtnWrapper = stickyCart.querySelector('.sb-atc__button');
        if (stickyCartButton) { 
          if (variant.available) {
            stickyCartButton.textContent = this.strings.addToCart;
            if (stickyCartBtnWrapper) stickyCartBtnWrapper.removeAttribute('disabled');
          } else {
            stickyCartButton.textContent = this.strings.soldOut;
            if (stickyCartBtnWrapper) stickyCartBtnWrapper.setAttribute('disabled', 'disabled');
          }
        }
      }
    }

    this.sync(variant);
  }

  updateVariantLabels(variantId) {
    const labels = this.querySelectorAll('[data-sb-variant-label]');
    labels.forEach((el) => {
      el.classList.toggle(
        'is-active',
        el.getAttribute('data-sb-variant-label') === String(variantId)
      );
    });
  }

  updateVariantSize(variantId) {
    const sizeEl = document.querySelector('.sb-product-info__size');
    if (!sizeEl) return;
    const size = this.variantSizes?.[String(variantId)] || '';
    if (size) {
      sizeEl.textContent = size;
      sizeEl.style.display = '';
    } else {
      sizeEl.style.display = 'none';
    }
  }

  onPurchaseTypeChange() {
    const mode = this.querySelector('[name="purchase_type"]:checked')?.value ?? 'onetime';
    if (mode === 'subscribe' && this.freqSelect) {
      if (this.freqWrap) this.freqWrap.hidden = false;
      this.spInput.disabled = false;
      this.spInput.value = this.freqSelect.value;
    } else {
      if (this.freqWrap) this.freqWrap.hidden = true;
      this.spInput.disabled = true;
      this.spInput.value = '';
    }
    this.sync();
  }

  onFrequencyChange() {
    if (!this.spInput.disabled) {
      this.spInput.value = this.freqSelect.value;
    }
    this.sync();
  }

  sync(variantOverride) {
    const variant =
      variantOverride ??
      this.variants.find((v) => String(v.id) === String(this.idInput.value));
    if (!variant) return;

    const mode = this.querySelector('[name="purchase_type"]:checked')?.value ?? 'onetime';
    const planId = mode === 'subscribe' ? this.freqSelect?.value : null;
    const key = `${variant.id}:${planId || 'onetime'}`;

    if (this.priceEl) {
      this.priceEl.textContent =
        this.prices[key] ?? this.prices[`${variant.id}:onetime`] ?? this.priceEl.textContent;
    }

    const available = variant.available;
    if (this.atcBtn) this.atcBtn.toggleAttribute('disabled', !available);
    if (this.labelEl) {
      this.labelEl.textContent = available ? this.strings.addToCart : this.strings.soldOut;
    }
  }
}

if (!customElements.get('sb-product-form')) {
  customElements.define('sb-product-form', SbProductForm);
}
